import { useState, useCallback } from "react";
import type { TimeframePreset } from "@/hooks/useAdminData";

interface TimeframeState {
  preset: TimeframePreset;
  customFrom: string;
  customTo: string;
}

const PRESETS: { value: TimeframePreset; label: string }[] = [
  { value: "60m", label: "Last 60 min" },
  { value: "24h", label: "Last 24h" },
  { value: "7d", label: "Last 7 days" },
  { value: "30d", label: "Last 30 days" },
  { value: "90d", label: "Last 90 days" },
  { value: "custom", label: "Custom" },
];

export function useAdminTimeframe() {
  const [state, setState] = useState<TimeframeState>({
    preset: "30d",
    customFrom: "",
    customTo: "",
  });

  const setPreset = useCallback((preset: TimeframePreset) => {
    setState(s => ({ ...s, preset }));
  }, []);

  const setCustomRange = useCallback((from: string, to: string) => {
    setState({ preset: "custom", customFrom: from, customTo: to });
  }, []);

  return { ...state, setPreset, setCustomRange, PRESETS };
}
